import React from 'react';
import './InputFormsForAnswers.scss';
import {  openDeleteInputFormsForImageNotePart, noteImagePartDelete } from '../../../adminSlice';

export default class DeleteInputFormsForImageNotePart  extends React.Component {
    constructor(props) {
        super(props);
        
       
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;
        

         const item = {
            note_id: this.props.adminState.selectedIdNote,
            img_path: this.props.adminState.selectedDeletedImgPath,
                        
        }
   
    


       
        console.log(item);
       dispatch(noteImagePartDelete(item));
       dispatch(openDeleteInputFormsForImageNotePart()); 
        
}


// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(openDeleteInputFormsForImageNotePart());

}

   renderTable() {
       return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openDeleteInputFormsForImageNotePart) {
        return(
            <div className="InputFormsForAnswers">
                           


             <p><b>Вы действительно хотите удалить изображение?</b></p>
             
             <button onClick={this.onSend}>Да</button>
             <button onClick={this.onClose}>Отмена</button>
            </div>
        )
     } else return null;
       
     

        
    }
}